module.exports = __webpack_public_path__ + "static/13-505e7faddc5e0d2e5550d8d25bb9aa95.png";